import { anim, prog, stagger } from '../../../../motion'
import { Fit, Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import poster from '../../media/dashboard-analyse.jpg'
import video from '../../media/dashboard-analyse.mp4'
import { MaskText, ScrollVideo } from '../../stage/fx'

export const ANALYSE_PARTICLES = [
  [0.1, () => ({ type: 'scatter', alpha: 0.22 })],
  [0.9, () => ({ type: 'scatter', alpha: 0.22, seed: 23 })]
]

const NARROW = { maxW: 0.94, maxH: 0.42 }

// Ein Laptop klappt sich aus der Tiefe auf, darauf läuft die echte Anforderungsanalyse
export default function DmsAnalyse() {
  const c = useCopy('analyse')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='dms-analyse-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={s.analyseTitle} at={[0.02, 0.14]} />
        </h2>
      </div>

      <Fit
        w={960}
        h={620}
        maxW={0.66}
        maxH={0.62}
        narrow={NARROW}
        className='dms-laptop-fit'
      >
        <div
          className='dms-laptop'
          style={{
            ...prog([0.06, 0.32]),
            transform:
              'translateY(calc((1 - var(--p)) * 180px)) rotateX(calc((1 - var(--p)) * 52deg)) scale(calc(0.8 + 0.2 * var(--p)))'
          }}
        >
          <div className='dms-laptop__screen'>
            <ScrollVideo
              src={video}
              poster={poster}
              at={[0.2, 1]}
              label={s.analyseVideo}
              className='dms-laptop__video'
            />
          </div>
          <div className='dms-laptop__base' />
        </div>
      </Fit>

      <div className='dms-analyse-chips'>
        {c.sources.map((src, i) => (
          <span
            key={src}
            className={`sc-chip dms-float dms-float--${i}`}
            style={anim({ at: stagger(0.36, 0.06, 0.08, i), y: 40, s: 0.8 })}
          >
            {src}
          </span>
        ))}
      </div>

      <div
        className='dms-analyse-foot'
        style={anim({ at: [0.6, 0.68], y: 30 })}
      >
        {c.chips.map((chip) => (
          <span key={chip} className='sc-chip'>
            {chip}
          </span>
        ))}
      </div>
    </div>
  )
}
